<script>
export default {
  props: {
    webhook: {
      required: true
    }
  },
  computed: {
    creating() {
      return this.webhook === null
    },
    ready() {
      return ! this.loading.dataset && ! this.loading.item
    },
    updateUrl() {
      return this.createUrl + '/' + this.item.hash
    },
    createUrl() {
      return window.location.origin + window.location.pathname
    }
  },
  data: () => ({
    loading: {
      dataset: false,
      item: false,
      submit: false
    },
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
    item: {
      webhook_url: '',
      secret_token: null,
      hooks: [],
      disabled_at: null,
    },
    rules: {
      webhook_url: [
        { required: true, message: "Webhook URL must not empty.", trigger: 'blur'}
      ],
      hooks: [
        { required: true, message: "Hooks must not empty." }
      ]
    },
    dataset: {
      events: []
    }
  }),
  created() {
    this.getDataset()

    if (this.webhook instanceof Object)
      this.item = this.webhook

    if (this.webhook instanceof String)
      this.getItem()
  },
  methods: {
    getItem() {
      this.loading.item = true
      this.$http.get(this.routeUri('hyperion.setting.webhook.show', {webhook_hash: this.webhook }))
        .then((r) => this.item = r.data)
        .catch((e) => this.handleXhrError(e))
        .finally(() => this.loading.item = false)
    },
    getDataset() {
      this.loading.dataset = true
      this.$http.get(this.routeUri('hyperion.setting.webhook.dataset'))
        .then((r) => this.dataset = r.data)
        .catch((e) => this.handleXhrError(e))
        .finally(() => this.loading.dataset = false)
    },
    reload() {
      this.$notification.success({
        message: "Success",
        description: "Data has been successfully saved!",
        onClose: () => window.location.reload()
      });
    },
    update() {
      this.$http.put(this.updateUrl, this.item)
      .then(() => this.reload())
      .catch((e) => this.handleXhrError(e))
    },
    create() {
      this.$http.post(this.createUrl, this.item)
        .then(() => this.reload())
        .catch((e) => this.handleXhrError(e))
    },
    submit() {
      this.$refs.webhookForm.validate(valid => {
        if (valid) {
          this.loading.submit = true
          this.creating ? this.create() : this.update()
        } else {
          return false;
        }
      })
    }
  },
}
</script>
<template>
  <div>
    <h3>{{ creating ? 'Create new webhook' : 'Edit webhook' }}</h3>
    <a-divider dashed />
    <a-card type="inner" size="small">
      <a-skeleton :loading="! ready">
        <a-form-model ref="webhookForm" :labelCol="labelCol" :wrapperCol="wrapperCol" :model="item" :rules="rules">
          <a-form-model-item label="Webhook URL" prop="webhook_url">
            <a-input v-model="item.webhook_url">
              <a-icon slot="prefix" type="link" />
            </a-input>
          </a-form-model-item>

          <a-form-model-item label="Secret Token">
            <a-input v-model="item.secret_token" name="secret_token">
              <a-icon slot="prefix" type="key" />
            </a-input>
          </a-form-model-item>

          <a-form-model-item label="Events Hook" prop="hooks">
            <a-checkbox-group v-model="item.hooks">
              <div v-for="(item,index) in dataset.events" :key="`hook-event-${index}`">
                <a-checkbox :value="item">
                  <strong><code>{{ item }}</code></strong>
                </a-checkbox>
              </div>
            </a-checkbox-group>
          </a-form-model-item>

          <a-form-model-item :wrapperCol="{span: wrapperCol.span, offset: labelCol.span }">
            <a-button :loading="loading.submit" type="primary" @click="submit" icon="save">Save</a-button>
          </a-form-model-item>
        </a-form-model>
      </a-skeleton>
    </a-card>
  </div>
</template>
